import axios from 'axios';
import {rootUrl} from './rootUrl.js';
export let login={
  auth(params) {
    return axios.post(rootUrl + '/login/auth', params)
  },
  logout(params) {
    return axios.post(rootUrl + '/login/logout', params)
  },
  regist(params) {
    return axios.post(rootUrl + '/login/regist', params)
  },
  getAuthorizeUrl(params) {
    return axios.post(rootUrl + '/login/getAuthorizeUrl', params)
  },
  getAuthorizeCode(params) {
    return axios.post(rootUrl + '/login/getAuthorizeCode', params)
  },
  weixin(params) {
    // rootUrl = 'domain:http://mtestsso.kangxin.com'
    return axios.post(rootUrl + '/wechat/login', params)
  },
  recordUser(params) {
    return axios.post(rootUrl + '/member/recordUser', params)
  },
};



// WEBPACK FOOTER //
// ./src/service/login.js